<template>
  <section>
    <div class="mt-8 mb-4">
      <h3 class="text-2xl font-semibold">{{ $t('schedule.videoRecords.heading') }}</h3>
    </div>
    <div class="schedules-list overflow-y-scroll max-h-82 mb-8">
      <table v-if="trainings.length > 0" class="schedules-table">
        <thead>
          <tr>
            <th class="px-1 schedules-table-header">
              {{ $t('schedule.videoRecords.list.table.ths.th1') }}
            </th>
            <th class="px-1 schedules-table-header">
              {{ $t('schedule.videoRecords.list.table.ths.th2') }}
            </th>
            <th class="px-1 schedules-table-header">
              {{ $t('schedule.videoRecords.list.table.ths.th3') }}
            </th>
            <th class="px-1 schedules-table-header">
              {{ $t('schedule.videoRecords.list.table.ths.th4') }}
            </th>
            <th class="px-1 schedules-table-header">
              {{ $t('schedule.videoRecords.list.table.ths.th5') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="training in trainings" :key="`video-record-${training.id}`">
            <td class="schedules-table-data">{{ formatDate(training.trainingTime) }}</td>
            <td class="schedules-table-data">{{ formatTime(training.trainingTime) }}</td>
            <td class="schedules-table-data">{{ training.machine }}</td>
            <td class="schedules-table-data">
              <span v-if="training.trainingTopic">{{ training.trainingTopic }}</span>
              <span v-else>-</span>
            </td>
            <td class="schedules-table-data">
              <a
                :href="training.videoRecordUrlComplete"
                target="_blank"
                class="p-1 px-5 font-semibold text-white bg-blue-500 rounded-full hover:bg-blue-700 transition-colors duration-75 cursor-pointer"
              >
                {{ $t('schedule.videoRecords.list.table.btn') }}
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else>
        <div class="schedules-no-data mb-0">
          {{ $t('schedule.videoRecords.noData') }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { parseISO, format } from 'date-fns';

export default {
  name: 'ScheduleVideoRecord',
  components: {},
  props: { trainings: Array },
  data() {
    return {};
  },
  computed: {},
  methods: {
    formatDate(dateStr) {
      return format(parseISO(dateStr), 'MMM d, yyy');
    },
    formatTime(dateStr) {
      return format(parseISO(dateStr), "h:mm aaaa '( EASTERN TIME )'");
    },
  },
};
</script>
